import { render, staticRenderFns } from "./resetPasswordStaff.vue?vue&type=template&id=8dfc3a18&scoped=true&"
import script from "./resetPasswordStaff.vue?vue&type=script&lang=js&"
export * from "./resetPasswordStaff.vue?vue&type=script&lang=js&"
import style0 from "./resetPasswordStaff.vue?vue&type=style&index=0&id=8dfc3a18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfc3a18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VContainer,VFlex,VForm,VLayout,VTextField})
